import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["checked", "name", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", { for: _ctx.idRadio }, [
    _createElementVNode("input", {
      checked: _ctx.isChecked,
      type: "radio",
      name: _ctx.questaoId,
      id: _ctx.idRadio,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitirOpcaoSelecionada()))
    }, null, 8, _hoisted_2),
    _createTextVNode(" " + _toDisplayString(_ctx.opcao.getLabel()), 1)
  ], 8, _hoisted_1))
}